import * as React from 'react';
import { Link } from "react-router-dom";
import { NavLink } from 'reactstrap';
import { If } from '../../../core/components/If';
import { IComponentDataItem } from '../../../core/types/IComponentDataItem';
import { IComponentField } from '../../../core/types/IComponentField';
import { ILookupInstance } from '../../../lookup/types/ILookup';
import {
    addFileToUpload,
    CleanUploadFilesState,
    editingChanged,
    fileMetadataChanged,
    matchNow,
    setInDropZone,
    setProgressUploadFileProccess,
    toggleSidebarCollapsed,
    validationMessageChanged
} from '../../../redux/reducers/DataIngestionReducer';
import { hideModal, showModal, showYesNoPrompt } from '../../../redux/reducers/ModalReducer';
import {
    addDroppedFile,
    cleanDroppedFilesRepertoireState,
    clearModalSearchResults,
    setProgressUploadFileRepertoireProccess
} from '../../../redux/reducers/RepertoireReducer';
import { IAttachedFile } from '../../../redux/types/IAttachedFile';
import IDroppedFiles from '../../../redux/types/IDroppedFiles';
import IFile from '../../../redux/types/IFiles';
import { IJobState } from '../../../redux/types/IJobState';
import { IPaginationDetail } from '../../../redux/types/IPaginationDetail';
import {
    AGREEMENTS_KEY,
    ATTACHMENT_TYPE_NOT_REQUIRED,
    PRODUCTS_PAGE_VIEW,
    SEARCH_VIEW,
    WORKS_PAGE_VIEW
} from '../../../repertoire/Consts';
import { DataSource } from '../../../repertoire/types/DataSource';
import { ITreeData } from '../../../repertoire/types/ITreeData';
import { IDistribution } from "../../../repertoire/types/usageTypes/IDistribution";
import { IUsagePool } from '../../../repertoire/types/usageTypes/IUsagePool';
import {
    ALL_ROLES,
    CONTAINER_DETAILS_WINDOW_KEY,
    CONTRIBUTE_INGESTION_REPERTOIRE_ROLE,
    CONTRIBUTE_INGESTION_USAGE_ROLE,
    CONTRIBUTE_PAYMENT_ROLE,
} from '../../Consts';
import { FileSystemHelper } from '../../services/FileSystemHelper';
import { StorageService } from '../../services/StorageService';
import { IFileSystem } from '../../types/IFileSystem';
import { IStoragePathItemData } from '../../types/IStoragePathItemData';
import { SaveState } from '../../types/SaveState';
import {
    CANCEL_BUTTON_TEXT_FIELD,
    CANCELLED_MESSAGE_FIELD,
    DISABLE_DRAG_AND_DROP,
    DISABLE_DRAG_AND_DROP_AGREEMENTS,
    DISABLE_DRAG_AND_DROP_PRODUCTS,
    DRAG_AND_DROP_INSTRUCTION,
    UPLOAD_FILE_BUTTON_TEXT,
    DRAG_INSTRUCTION,
    DROP_INSTRUCTION,
    ERROR_INVALID_FILE_NAME_OR_FOLDER,
    ERROR_OBTAINING_SAS,
    ERROR_UPLOADING_FILE_SAS,
    ERROR_ZIPPED_FILE,
    INGESTION_PROCESS_STARTED_FIELD,
    OBTAINED_SAS,
    PATH_TO_DROP_FILE,
    PREVENT_REFRESH_FIELD,
    REQUEST_SAS,
    SAVE_BUTTON_TEXT_FIELD,
    SAVE_FAILED_MESSAGE_FIELD,
    SAVE_SUCCESSFUL_MESSAGE_FIELD,
    UNDO_INGESTION_PROCESS_STARTED_FIELD,
    UPLOAD_COMPLETED,
    UPLOADING_FILE_SAS,
    VALIDATION_ERROR_MESSAGE
} from './ContainerDetailsWindowFields';
import { DataIngestionToolbar } from '../dataIngestionToolbar/DataIngestionToolbar';
import {
    addDroppedFile as mpAddDroppedFile,
    cleanDroppedFilesRepertoireState as mpCleanDroppedFilesRepertoireState,
    setProgressUploadFileRepertoireProccess as mpSetProgressUploadFileRepertoireProccess
} from "../../../redux/reducers/MembersPortalReducer";
import { ILookupDictionary } from '../../../lookup/types/ILookupDictionary';
import { ITabReduxItem } from '../../../redux/types/ITabReduxItem';
import { MessageBanner, MessageType } from '../../../repertoire/components/messageBanner/MessageBanner';
import { isNullOrUndefined } from '../../../util/tools';
import { UndoState } from "../../types/UndoState";
import DataIngestionTable from "../dataIngestionTable/DataIngestionTable";
import { getLookupValues } from '../../../lookup/services/LookupHelpers';
import { AGREEMENT_ATTACHMENT_TYPE_LOOKUP, PRODUCT_ATTACHMENT_TYPE_LOOKUP, WORK_ATTACHMENT_TYPE_LOOKUP } from '../../../lookup/Consts';
import ResponsiveRenderer from '../../../core/components/responsiveRenderer/ResponsiveRenderer';
import { DataIngestionTableDivs } from '../dataIngestionTableDivs/DataIngestionTableDivs';


export interface IContainerDetailsWindowProps {
    containerDetailsWindowComponentData: IComponentDataItem;
    storagePathItemData: IComponentDataItem;
    pageContentIsActive: boolean;
    storagePaths: IStoragePathItemData[];
    fileMetadataChanged?: typeof fileMetadataChanged;
    saveChanges?: (fileSystem: IFileSystem, storagePaths: IStoragePathItemData[], sources: ITreeData[]) => void;
    cancelChanges?: (fileSystem: IFileSystem, sources: ITreeData[]) => void;
    openDirectory?: (filesystem: IFileSystem, sources: ITreeData[]) => void;
    refreshDirectory?: (filesystem: IFileSystem, sources: ITreeData[]) => void;
    currentDirectory?: string;
    toggleSidebarCollapsed?: typeof toggleSidebarCollapsed;
    validationMessageChanged?: typeof validationMessageChanged;
    saveState?: SaveState;
    distributions?: IDistribution[];
    destinations?: ILookupInstance[];
    lookupValues?: ILookupDictionary;
    editingChanged?: typeof editingChanged;
    selectedFileSystem?: IFileSystem;
    jobs?: IJobState[];
    matchNow?: typeof matchNow;
    matchNowSubmit?: (fileSystem: IFileSystem, storagePaths: IStoragePathItemData[], sources: ITreeData[]) => void;
    droppedFiles: IDroppedFiles;
    setInDropZone: typeof setInDropZone;
    addFileToUpload: typeof addFileToUpload;
    isDropZone: boolean;
    setProgressUploadFileProccess: typeof setProgressUploadFileProccess;
    cleanUploadFilesState: typeof CleanUploadFilesState;
    isRepertoireModule?: boolean;
    addRepertoireAttachmentToState?: (attachedFile: IAttachedFile) => void;
    uploadAttachment?: (fileName: string, id: number, dataSource: DataSource) => Promise<any>;
    removeAttachmentIfExists?: (attachedFile: IAttachedFile, source: DataSource) => void;
    attachmentsDropped?: IDroppedFiles;
    addDroppedFileRepertoire?: typeof addDroppedFile | typeof mpAddDroppedFile;
    setProgressUploadFileRepertoire?: typeof setProgressUploadFileRepertoireProccess | typeof mpSetProgressUploadFileRepertoireProccess;
    cleanDroppedFilesRepertoire?: typeof cleanDroppedFilesRepertoireState | typeof mpCleanDroppedFilesRepertoireState;
    agreementAttachmentsDropped?: IDroppedFiles;
    entityID?: number;
    entitySource?: DataSource;
    component?: string;
    removeAttachmentMaintenanceScreen?: (fullName: string, workId: number, dataSource: DataSource, guid: string, index: number) => void;
    deleteBlobFile?: (fullName: string, name: string) => Promise<boolean>;
    displayRemove?: boolean;
    paginationDetails?: IPaginationDetail[];
    updatePagination?: (resultsPerPage: number, currentPage: number, section: string) => void;
    getMatchingSources?: () => void;
    pools?: IUsagePool[];
    undoUsageIngestion?: (fullFilePath: string) => void;
    showYesNoPrompt?: typeof showYesNoPrompt;
    showModal?: typeof showModal;
    hideModal?: typeof hideModal;
    clearModalSearchResults?: typeof clearModalSearchResults;
    dataIngestionToolbarData?: IComponentDataItem;
    roles?: string[];
    activeTab?: number;
    tabs?: ITabReduxItem[];
    isWorkAttachmentTypeNotRequired?: boolean;
    isWorkAttachmentTypeOptional?: boolean;
    isProductAttachmentTypeNotRequired?: boolean;
    isProductAttachmentTypeOptional?: boolean;
    currentUserNameNumber?: string;
    agreementAttachmentTypeRequired?: string;
    resetMessageBanner?: () => void;
    updatedScroll?: number;
    undoState?: UndoState;
    undoErrorMessage?: string;
    getDistributionDetails?: (distributionID: number, lookupValues: ILookupDictionary) => void;
    getUsagePool?: (poolId: number, matchingSources: ITreeData[], isPoolMaintainence?: boolean) => void;
    matchingSources?: ITreeData[];
    formats?: ILookupInstance[];
    sources?: ITreeData[];
    titleContains?: string;
    distributionsFilter?: string[];
    renderDragFilesUpload?: boolean;
    updateAttachmentType?: (fullName: string, attachmentTypeCode: string) => void;
	displayResponsiveGrid?: boolean;
    attachmentTypeColumnWidth?: number | string;    
}

interface IContainerDetailsWindowState {
    tableContents: any;
    loaded: boolean;
    downloadSchemaLink?: string;
    pendingMatchNowSubmitKey?: string | null;
    uploadSuccess?:boolean;
    uploadInProgress?: boolean;
}

export class ContainerDetailsWindow extends React.Component<
    IContainerDetailsWindowProps,
    IContainerDetailsWindowState
> {

    toolbarParentRef;
    viewData;
    downloadSchemaAnchorRef: React.RefObject<HTMLAnchorElement>;
    constructor(props: IContainerDetailsWindowProps) {
        super(props);

        this.state = {
            loaded: false,
            tableContents: props.storagePaths,
            downloadSchemaLink: undefined,
            pendingMatchNowSubmitKey: null
        };

        this.viewData = {};
        this.toolbarParentRef = React.createRef();
        this.downloadSchemaAnchorRef = React.createRef();
        this.handleFileInputChange = this.handleFileInputChange.bind(this);
    }

    componentDidMount() {
        this.loadFields();
        const {
            sources,
            getMatchingSources,
        } = this.props;
        if (getMatchingSources && !sources) {
            getMatchingSources();
        }
    }

    componentDidUpdate = (prevProps: IContainerDetailsWindowProps) => {
        const { storagePaths, selectedFileSystem, matchNowSubmit, sources, containerDetailsWindowComponentData } = this.props;

        const hasFields = !!containerDetailsWindowComponentData?.fields && containerDetailsWindowComponentData.fields.length > 0;
        if (!this.state.loaded && hasFields) {
            this.loadFields();
        }

        if (prevProps.storagePaths !== storagePaths) {
            this.setState({ tableContents: storagePaths }, () => {
                if (this.state.pendingMatchNowSubmitKey !== null) {
                    matchNowSubmit?.(selectedFileSystem, this.state.tableContents, sources);
                    this.setState({ pendingMatchNowSubmitKey: null });
                }
            });
        }

        if (selectedFileSystem) {
            const schemaDownloadLinks = {
                'accounts': "/assets/SchemaFiles/Account/account_schema.json",
                'agreements': "/assets/SchemaFiles/Agreement/agreement_schema.json",
                'works': "/assets/SchemaFiles/WorkToWorkMatching/work_to_work_matching_schema.json",
                'usage': "/assets/SchemaFiles/UsageToUsageMatching/usage_module_schema.json",
                'repertoire': "/assets/SchemaFiles/ProductToProductMatching/product_to_product_matching_schema.json",
            };
            if (
                selectedFileSystem.parent?.name in schemaDownloadLinks
                &&
                shouldShowChildLink(selectedFileSystem.parent?.name, selectedFileSystem.name)
            ) {
                if (this.state.downloadSchemaLink !== schemaDownloadLinks[selectedFileSystem.parent?.name])
                    this.setState({ downloadSchemaLink: schemaDownloadLinks[selectedFileSystem.parent?.name] });
            }
            else {
                if (this.state.downloadSchemaLink !== undefined) this.setState({ downloadSchemaLink: undefined });
            }
        }

        function shouldShowChildLink(parent: string, name: string) {
            const childrenFileSystems = new Map([
                ['repertoire', ['cues', 'recordings', 'products']]
            ]);

            const vals = childrenFileSystems.get(parent);
            if (vals === undefined)
                return true;

            return vals.includes(name);
        }
    };

	protected createUploadFile(file: File): IFile {
		return {
			message: '',
			name: file.name,
			size: file.size,
			isInProgress: true
		};
	}

    loadFields() {

        const { loaded } = this.state;
        const { containerDetailsWindowComponentData: { fields } } = this.props;
        if (!loaded) {
            if (!this.props.containerDetailsWindowComponentData) {
                return;
            }
            if (fields) {
                this.viewData = {};
                fields.forEach(item => {
                    this.viewData[item.name] = item.data;
                });

                this.setState({ loaded: true });
            }
        }
    }

    renderSaveAndCancelButtons(showMetadata: boolean): JSX.Element {
        const { storagePaths, saveChanges, selectedFileSystem, cancelChanges, isRepertoireModule, sources } = this.props;
        const showButtons: boolean = showMetadata && !isNullOrUndefined(storagePaths.find(s => s.isEditing));
        const disabled: boolean = isNullOrUndefined(storagePaths.find(s => s.isDirty));

        if (isRepertoireModule)
            return null;

        return <div className="row">
            <If condition={showButtons}>
                <div>
                    <div className="form-group col-lg-3 col-lg-push-6 col-md-4 col-md-push-4 col-sm-6 col-sm-push-0 col-xs-6 col-xs-push-0">
                        <button className="button btn-defaultSecondary" disabled={false}
                            onClick={() => cancelChanges(selectedFileSystem, sources)}>
                            {this.viewData[CANCEL_BUTTON_TEXT_FIELD]}
                        </button>
                    </div>

                    <div className="form-group col-lg-3 col-lg-push-6 col-md-4 col-md-push-4 col-sm-6 col-sm-push-0 col-xs-6 col-xs-push-0">
                        <button className="button btn-defaultPrimary" disabled={disabled}
                            onClick={() => saveChanges(selectedFileSystem, storagePaths, sources)}>
                            {this.viewData[SAVE_BUTTON_TEXT_FIELD]}
                        </button>
                    </div>
                </div>
            </If>
        </div>
    }

    renderUndoStateMessage(): JSX.Element {
        const { resetMessageBanner } = this.props;
        return <div>
            <If condition={this.props.undoState === UndoState.Succeeded}>
                <div className="row">
                    <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={[this.viewData[UNDO_INGESTION_PROCESS_STARTED_FIELD]]} />
                </div>
            </If>
            <If condition={this.props.undoState === UndoState.Failed}>
                <div className="row">
                    <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Danger} messages={[this.props.undoErrorMessage || this.viewData[SAVE_FAILED_MESSAGE_FIELD]]} />
                </div>
            </If>
        </div>
    }

    renderSaveStateMessage(): JSX.Element {
        const { isRepertoireModule, resetMessageBanner } = this.props;
        if (isRepertoireModule)
            return null;

        return <div>
            {/* Save ingestion started*/}
            <If condition={this.props.saveState === SaveState.IngestionProcessStaredMessage}>
                <div className="row">
                    <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={[this.viewData[INGESTION_PROCESS_STARTED_FIELD]]} />
                </div>
            </If>

            {/* Save success */}
            <If condition={this.props.saveState === SaveState.SaveSucceeded}>
                <div className="row">
                    <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Success} messages={[this.viewData[SAVE_SUCCESSFUL_MESSAGE_FIELD]]} />
                </div>
            </If>

            {/* Save failure */}
            <If condition={this.props.saveState === SaveState.SaveFailed}>
                <div className="row">
                    <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Danger} messages={[this.viewData[SAVE_FAILED_MESSAGE_FIELD]]} />
                </div>
            </If>

            {/* Cancelled */}
            <If condition={this.props.saveState === SaveState.Cancelled}>
                <div className="row">
                    <MessageBanner resetMessageBanner={resetMessageBanner} messageType={MessageType.Warning} messages={[this.viewData[CANCELLED_MESSAGE_FIELD]]} />
                </div>
            </If>
        </div>
    }

    renderTable(): JSX.Element {
        const { storagePathItemData, selectedFileSystem, isRepertoireModule, displayRemove, isWorkAttachmentTypeNotRequired, isProductAttachmentTypeNotRequired,
            currentDirectory, agreementAttachmentTypeRequired, storagePaths, containerDetailsWindowComponentData, distributions, destinations, getDistributionDetails,
            getUsagePool, matchingSources, formats, sources, titleContains, distributionsFilter, pools, jobs, undoUsageIngestion, showYesNoPrompt, hideModal, editingChanged,
            fileMetadataChanged, lookupValues, activeTab, tabs, openDirectory,isProductAttachmentTypeOptional,attachmentTypeColumnWidth } = this.props;

        if (!selectedFileSystem)
            return <thead>
                <tr>
                    <td></td>
                    <td></td>
                </tr>
            </thead>
        
        const isDisplayAttachmentType = (currentDirectory === "work" && !isWorkAttachmentTypeNotRequired) ||
            (currentDirectory === "usage" && !isWorkAttachmentTypeNotRequired) ||
            (currentDirectory === "product" && (!isProductAttachmentTypeNotRequired || isProductAttachmentTypeOptional)) ||
            (currentDirectory === "agreement" && agreementAttachmentTypeRequired != ATTACHMENT_TYPE_NOT_REQUIRED)
        const displayRemoveColumn = isRepertoireModule && displayRemove === true

        let attchmentTypeLookupOptions = [];
        switch (currentDirectory) {
            case "work":
                attchmentTypeLookupOptions = getLookupValues(WORK_ATTACHMENT_TYPE_LOOKUP, lookupValues);
                break;
            case "product":
                attchmentTypeLookupOptions = getLookupValues(PRODUCT_ATTACHMENT_TYPE_LOOKUP, lookupValues);
                break;
            case "agreement":
                attchmentTypeLookupOptions = getLookupValues(AGREEMENT_ATTACHMENT_TYPE_LOOKUP, lookupValues);
        }
		
        return (
            <div className="tableContainer">
                <DataIngestionTable
                    containerDetailsWindowComponentData={containerDetailsWindowComponentData}
                    storagePaths={storagePaths}
                    storagePathItemData={storagePathItemData}
                    distributions={distributions}
                    destinations={destinations}
                    getDistributionDetails={getDistributionDetails}
                    getUsagePool={getUsagePool}
                    matchingSources={matchingSources}
                    formats={formats}
                    sources={sources}
                    titleContains={titleContains}
                    distributionsFilter={distributionsFilter}
                    selectedFileSystem={selectedFileSystem}
                    isRepertoireModule={isRepertoireModule}
                    pools={pools}
                    jobs={jobs}
                    canEditMetadata={selectedFileSystem && selectedFileSystem.canEditMetadata}
                    determineIsReadOnly={this.determineIsReadOnly}
                    deleteFile={this.deleteFile.bind(this)}
                    editingChanged={editingChanged}
                    matchNow={(data) => this.matchNowUpdate(data)}
                    undoUsageIngestion={undoUsageIngestion}
                    showYesNoPrompt={showYesNoPrompt}
                    hideModal={hideModal}
                    fileMetadataChanged={fileMetadataChanged}
                    displayAttachmentType={isDisplayAttachmentType}
                    displayRemoveColumn={displayRemoveColumn}
                    removeAttachmentFromMaintenanceScreen={this.removeAttachmentFromMaintenanceScreen.bind(this)}
                    attchmentTypeLookupOptions={attchmentTypeLookupOptions}
                    activeTab={activeTab}
                    tabs={tabs}
                    openDirectory={openDirectory}
                    showSearchModal={this.showSearchModal}
                    onDownloadFile={this.onDownloadFile.bind(this)}
                    viewData={this.viewData}
                    attachmentTypeChanged={this.handleAttachmentTypeChanged.bind(this)}
                    attachmentTypeColumnWidth={attachmentTypeColumnWidth}
                />
            </div>
        );
    }

    showSearchModal = (modalProps: any, searchViewKey: string) => {
        const { showModal } = this.props;
        showModal(SEARCH_VIEW, searchViewKey, modalProps, true, "Search");
    };

    determineIsReadOnly = (storagePathFullName: string): boolean => {
        const { roles } = this.props;
        if (roles && !(roles.includes(CONTRIBUTE_INGESTION_USAGE_ROLE) || roles.includes(ALL_ROLES))) {
            if (storagePathFullName.startsWith('usage')) {
                return true;
            }
        }
        if (roles && !(roles.includes(CONTRIBUTE_INGESTION_REPERTOIRE_ROLE) || roles.includes(ALL_ROLES))) {
            if (storagePathFullName.startsWith('repertoire')) {
                return true;
            }
        }
        if (roles && !(roles.includes(CONTRIBUTE_PAYMENT_ROLE) || roles.includes(ALL_ROLES))) {
            if (storagePathFullName.startsWith('payments')) {
                return true;
            }
        }
        return false;
    }

    onClick(fileSystem: IFileSystem): void {
        if (fileSystem)
            this.props.refreshDirectory(fileSystem, this.props.sources);
    }

    onDownloadFile(data: any, isRepertoireModule): void {
        if (!data.isDirectory) {
            StorageService.downloadFile(data.fullName, isRepertoireModule, data.name).then(
                (downloadLink: string) => {
                    if (downloadLink && downloadLink.length > 0 && !isRepertoireModule) {
                        const link = document.getElementById("downloadLinkDataIngestion");
                        link.setAttribute('href', downloadLink);
                        link.click();
                        link.removeAttribute('href');
                    }
                    else if (downloadLink && downloadLink.length > 0 && isRepertoireModule) {
                        const link = document.getElementById("downloadRepertoireAttachments");
                        link.setAttribute('href', downloadLink);
                        link.click();
                        link.removeAttribute('href');
                    }
                }
            );
        }
    };

    matchNowUpdate(data: any): void {
        const { matchNow, storagePathItemData, validationMessageChanged } = this.props;
        const dir: string = data.fullName.replace('/' + data.name, '');
        const fields: IComponentField[] = storagePathItemData.fields.filter(f => f.componentInstance === dir);
        const index: number = this.props.storagePaths.findIndex((item: IStoragePathItemData) => item.fullName === data.fullName);
        let allSet: boolean = fields.every((field, i) => {
            if (field.name === 'trackingInformation') {
                return true;
            }
            return data.metadata[field.name];
        });
        if (allSet) {
            data.validationError = null;
            matchNow(data);
            this.setState({ pendingMatchNowSubmitKey: data.key });
        }
        else {
            validationMessageChanged(this.viewData[VALIDATION_ERROR_MESSAGE], index);
        }
    }

    renderBreadcrumbs(): JSX.Element {
        const filesystem = this.props.selectedFileSystem;
        const { isRepertoireModule } = this.props;
        if (!filesystem || isRepertoireModule)
            return null;

        const filesystems = FileSystemHelper.getAncestors(filesystem);
        const links: JSX.Element[] = [];
        let idx: number = 0;

        if (filesystems.length > 0) {
            links.push(<NavLink tag={Link} to="#" key={idx++} onClick={() => this.onClick(filesystems[0])}>
                <span className="icon ms-Icon ms-Icon--FabricFolder"></span>{filesystems[0].name}
            </NavLink>);
        }

        for (let i = 1; i < filesystems.length; i++) {
            links.push(<i key={idx++} className="icon-separator ms-Icon ms-Icon--ChevronRightMed"></i>);
            links.push(<NavLink tag={Link} to="#" key={idx++} onClick={() => this.onClick(filesystems[i])}>{filesystems[i].name}</NavLink>);
        }

        return <div className="row">
            <div className="col-md-12">
                <button type="button" id="sidebarCollapse" className="navbar-toggle btnLateralmenu"
                    onClick={this.props.toggleSidebarCollapsed}>
                    <i className="glyphicon glyphicon-th" ></i>Data Ingestion Options
                </button>
                <div className="breadcrumb">
                    {links}
                </div>
            </div>
        </div>
    }

    downloadSchema(): void {
        const link = this.downloadSchemaAnchorRef.current;
        if (link.href !== undefined) link.click();
    }

    renderHeaderSection(): JSX.Element {
        const filesystem = this.props.selectedFileSystem;
        const { isRepertoireModule, dataIngestionToolbarData, updatedScroll } = this.props;
        if (!filesystem || isRepertoireModule)
            return null;

        const filesystems = FileSystemHelper.getAncestors(filesystem);
        let title = null;

        if (filesystems.length > 0) {
            title = <span className="title" > {filesystems[0].name}</span>;
        }

        for (let i = 1; i < filesystems.length; i++) {
            title = <span className="title" > {filesystems[i].name}</span>;
        }

        return <div className="">
            <div><span className="title">{title}</span></div>

            {dataIngestionToolbarData &&
                <div id="toolbarContainer" className="DataIngestionToolbar collapse" ref={this.toolbarParentRef}>
                    <DataIngestionToolbar
                        scroll={updatedScroll}
                        toolbarData={dataIngestionToolbarData}
                        toolbarWidth={null}
                        component={CONTAINER_DETAILS_WINDOW_KEY}
                        refresh={() => { this.onClick(filesystem) }}
                        downloadSchema={this.state.downloadSchemaLink ? this.downloadSchema.bind(this) : undefined}
                    />
                    <a href={this.state.downloadSchemaLink} download ref={this.downloadSchemaAnchorRef} />
                </div>
            }

        </div>
    }

    removeAttachmentFromMaintenanceScreen(fullName: string, guid: string, index: number) {
        const { removeAttachmentMaintenanceScreen, entityID, entitySource } = this.props;

        removeAttachmentMaintenanceScreen(fullName, entityID, entitySource, guid, index);
    }

    deleteFile(fullName: string, name: string) {
        const { deleteBlobFile, refreshDirectory, selectedFileSystem } = this.props;

        deleteBlobFile(fullName, name).then((res: boolean) => {
            refreshDirectory(selectedFileSystem, this.props.sources);
        })
    }

    uploadFile(newFile: IFile, path: string, file: any) {
        const {
            addFileToUpload
            , setProgressUploadFileProccess
            , setInDropZone
            , isRepertoireModule
            , addDroppedFileRepertoire
            , setProgressUploadFileRepertoire
        } = this.props;

        if (!isRepertoireModule)
            addFileToUpload(newFile, true);
        else
            addDroppedFileRepertoire(newFile, true);

        setInDropZone(false);

        if (!isRepertoireModule)
            setProgressUploadFileProccess(this.viewData[REQUEST_SAS], newFile, false);
        else
            setProgressUploadFileRepertoire(this.viewData[REQUEST_SAS], newFile, false);
        return Promise.resolve(
            StorageService.getUploadUri(path, isRepertoireModule).then(
                (uri: string) => {
                    if (uri && uri.length > 0) {
                        if (!isRepertoireModule) {
                            setProgressUploadFileProccess(this.viewData[OBTAINED_SAS], newFile, false);
                            setProgressUploadFileProccess(this.viewData[UPLOADING_FILE_SAS], newFile, false);
                        } else {
                            setProgressUploadFileRepertoire(this.viewData[OBTAINED_SAS], newFile, false);
                            setProgressUploadFileRepertoire(this.viewData[UPLOADING_FILE_SAS], newFile, false);
                        }
                        return StorageService.uploadFile(uri, file).then(
                            (res: boolean) => {
                                if (res) {
                                    if (!isRepertoireModule)
                                        setProgressUploadFileProccess(this.viewData[UPLOAD_COMPLETED], newFile, true);
                                    else
                                        setProgressUploadFileRepertoire(this.viewData[UPLOAD_COMPLETED], newFile, true);
                                    return true;
                                }
                            },
                            (reject) => {
                                if (!isRepertoireModule)
                                    setProgressUploadFileProccess(this.viewData[ERROR_UPLOADING_FILE_SAS], newFile, true);
                                else
                                    setProgressUploadFileRepertoire(this.viewData[ERROR_UPLOADING_FILE_SAS], newFile, true);

                                return false;
                            }
                        )
                            .catch(error => {
                                return false;
                            })
                    }
                },
                (reject: string) => {
                    if (reject.includes(ERROR_ZIPPED_FILE))
                        setProgressUploadFileProccess(this.viewData[ERROR_ZIPPED_FILE], newFile, true);
                    else if (reject.includes(ERROR_INVALID_FILE_NAME_OR_FOLDER))
                        setProgressUploadFileProccess(this.viewData[ERROR_INVALID_FILE_NAME_OR_FOLDER], newFile, true);
                    else if (!isRepertoireModule)
                        setProgressUploadFileProccess(this.viewData[ERROR_OBTAINING_SAS], newFile, true);
                    else
                        setProgressUploadFileRepertoire(this.viewData[ERROR_OBTAINING_SAS], newFile, true);

                    return false;
                }
            )
        )
    }

    handleAttachmentTypeChanged(value: string, fieldName: string, fullName: string) {
        this.props.updateAttachmentType?.(fullName, value);
    }

    handleFileInputChange = (event) => {
        const files = Array.from(event.target.files);
        const syntheticEvent = {
            ...event,
            dataTransfer: { files },
            preventDefault: () => {},
        };
        this.handleDrop(syntheticEvent);
        event.target.value = '';
    }

    handleDrop = e => {
        const {
            selectedFileSystem
            , cleanUploadFilesState
            , isRepertoireModule
            , currentDirectory
            , entityID
            , entitySource
            , addRepertoireAttachmentToState
            , uploadAttachment
            , removeAttachmentIfExists
            , cleanDroppedFilesRepertoire
            , sources
        } = this.props;
        const files = [...e.dataTransfer.files];

        const validSectionPath: string = this.viewData[PATH_TO_DROP_FILE] as string;

        if (selectedFileSystem && (validSectionPath.split(',').map(x => x = x.toLocaleLowerCase()).includes(selectedFileSystem.name.toLocaleLowerCase()))) {

            if (!isRepertoireModule)
                cleanUploadFilesState();
            else
                cleanDroppedFilesRepertoire();

            files.forEach(file => {
                const newFile = this.createUploadFile(file);

                let fullPath: string = "";

                if (isRepertoireModule) {
                    fullPath = `${selectedFileSystem.fullName}/${currentDirectory}/${newFile.name}`;

                    uploadAttachment(newFile.name, entityID, entitySource)
                        .then((res: IAttachedFile) => {
                            const fileToUpload: IFile = { ...newFile };
                            fileToUpload.name = res.guid;
                            fullPath = `${selectedFileSystem.fullName}/${currentDirectory}/${fileToUpload.name}`;
                            this.uploadFile(newFile, fullPath, file).then(
                                (uploaded: boolean) => {
                                    if (!uploaded) {
                                        removeAttachmentIfExists(res, entitySource);
                                    }
                                    else {
                                        if (addRepertoireAttachmentToState) {
                                            addRepertoireAttachmentToState(res);
                                        }
                                    }
                                }
                            )
                                .catch((err: boolean) => {
                                    if (err == false)
                                        removeAttachmentIfExists(res, entitySource);
                                });
                        });
                }
                else {
                    fullPath = `${selectedFileSystem.fullName}/${newFile.name}`;

                    this.uploadFile(newFile, fullPath, file).then(
                        res => {
                            this.props.refreshDirectory(selectedFileSystem, sources);
                        });
                }

            });
        }
        e.preventDefault();
    };

    handleDragLeave = e => {
        const { setInDropZone, selectedFileSystem } = this.props;

        const validSectionPath: string = this.viewData[PATH_TO_DROP_FILE] as string;
        if (selectedFileSystem && (validSectionPath.split(',').map(x => x = x.toLocaleLowerCase()).includes(selectedFileSystem.name.toLocaleLowerCase())))
            setInDropZone(true);
        e.preventDefault();
        e.stopPropagation();
    };

    handleDragEnd = e => {
        const { setInDropZone, selectedFileSystem } = this.props;
        const validSectionPath: string = this.viewData[PATH_TO_DROP_FILE] as string;

        if (selectedFileSystem && (validSectionPath.split(',').map(x => x = x.toLocaleLowerCase()).includes(selectedFileSystem.name.toLocaleLowerCase())))
            setInDropZone(false);
        e.preventDefault();
        e.stopPropagation();
    };

    handleDragEnter = e => {
        const { setInDropZone, selectedFileSystem } = this.props;

        const validSectionPath: string = this.viewData[PATH_TO_DROP_FILE] as string;
        if (selectedFileSystem && (validSectionPath.split(',').map(x => x = x.toLocaleLowerCase()).includes(selectedFileSystem.name.toLocaleLowerCase())))
            setInDropZone(true);
        e.preventDefault();
        e.stopPropagation();
    };

    handleDragOver = e => {
        const { setInDropZone, selectedFileSystem } = this.props;

        const validSectionPath: string = this.viewData[PATH_TO_DROP_FILE] as string;
        if (selectedFileSystem && (validSectionPath.split(',').map(x => x = x.toLocaleLowerCase()).includes(selectedFileSystem.name.toLocaleLowerCase())))
            setInDropZone(true);
        e.preventDefault();
        e.stopPropagation();
    };

    renderUploadStages(files: IFile[]): JSX.Element {
        return <ul>
            {files.map((file: IFile) => {
                return (
                    <div className="containerStages">
                        <div className="subTittle2 bold textCenter">
                            <span className="">{this.viewData[PREVENT_REFRESH_FIELD]}</span>
                        </div>
                        <div className="row">
                            <li key={file.name}>
                                <span className='bold'>{file.name}</span>
                                <span className={file.isInProgress ? 'icon ms-Icon ms-Icon--SyncOccurence' : ''} ></span>
                            </li>
                        </div>
                        <span className="subTittle">{file.message}</span>
                    </div>
                )
            })}
        </ul>
    }

    renderStageBox(): JSX.Element {
        const {
            droppedFiles
            , isRepertoireModule
            , cleanUploadFilesState
            , attachmentsDropped
            , cleanDroppedFilesRepertoire
            , agreementAttachmentsDropped
        } = this.props;

		let files: IFile[] | undefined;
		let onClose: (() => void) | undefined;

		if (isRepertoireModule) {
			if (attachmentsDropped?.files?.length > 0) {
				files = attachmentsDropped.files;
				onClose = cleanDroppedFilesRepertoire;
			}
			else if (agreementAttachmentsDropped?.files?.length > 0) {
				files = agreementAttachmentsDropped.files;
				onClose = cleanDroppedFilesRepertoire;
			}
		}

		if (!files && droppedFiles?.files?.length > 0) {
			files = droppedFiles.files;
			onClose = cleanUploadFilesState;
		}

		if (!files?.length) {
			return null;
		}

		return (
			<div className="row">
				<div className="col-md-12 alert alert-success alert-dismissible fade in">
					<NavLink
						tag={Link}
						to="#"
						className="close"
						data-dismiss="alert"
						aria-label="close"
						onClick={onClose}
					>
						&times;
					</NavLink>

					{this.renderUploadStages(files)}
				</div>
			</div>
		);
    }

	protected shouldRenderDragFilesUpload(): boolean {
		return this.props.renderDragFilesUpload === undefined || !!this.props.renderDragFilesUpload;
	}

	protected renderResponsiveUploadButton(): JSX.Element {
		const { isRepertoireModule, displayResponsiveGrid } = this.props;

		if (!isRepertoireModule || !this.shouldRenderDragFilesUpload()) {
			return null;
		}
		
		return (
			<>
				<div className={`${displayResponsiveGrid ? 'desktop-files-row' : ''}`}>
					<div className="row textCenter" style={{ padding: '10px' }}>
						{this.viewData[DRAG_AND_DROP_INSTRUCTION]}
					</div>
				</div>

				{displayResponsiveGrid && (
					<div className="form-group col-md-12 mobile-upload-btn">
						<div className="formBox autoBar mobile-upload-btn-container">
							<div className="mobile-upload-btn" style={{ marginBottom: '16px' }}>
								<input
									type="file"
									id="file-upload-input"
									style={{ display: 'none' }}
									multiple
									onChange={this.handleFileInputChange}
								/>

								<button
									type="button"
									className="button btn-outline-defaultPrimary"
									onClick={() => document.getElementById('file-upload-input')?.click()}
								>
									<span
										className="icon ms-Icon ms-Icon--Attach"
										aria-hidden="true"
										style={{ marginRight: '6px' }}
									/>
									{this.viewData[UPLOAD_FILE_BUTTON_TEXT]}
								</button>
							</div>
						</div>
					</div>
				)}
			</>
		);
	}

	protected renderDesktopTable(): JSX.Element {
		return (
			<table className="dataTable">
				<tbody>
					{this.renderTable()}
				</tbody>
			</table>
		);
	}

	protected renderTabletTable(): JSX.Element {
		const { isRepertoireModule, displayRemove, jobs } = this.props;
		const displayRemoveColumn = isRepertoireModule && displayRemove === true;
		return (
			<DataIngestionTableDivs
				storagePathItemData={this.props.storagePathItemData}
				containerDetailsWindowComponentData={this.props.containerDetailsWindowComponentData}
				selectedFileSystem={this.props.selectedFileSystem}
				storagePaths={this.props.storagePaths}
				onDownloadFile={this.onDownloadFile.bind(this)}
				isRepertoireModule={this.props.isRepertoireModule}
				displayRemoveColumn={displayRemoveColumn}
				removeAttachmentFromMaintenanceScreen={this.removeAttachmentFromMaintenanceScreen.bind(this)}
				jobs={jobs}
			/>
		);
	}

	protected renderTableContainer(): JSX.Element {
		return (
			<div
				id="DragAndDropArea"
				className="dragAndDrop"
				onDragOver={this.handleDragOver}
				onDragEnter={this.handleDragEnter}
				onDrop={this.handleDrop}
			>
				{this.props.displayResponsiveGrid ? (
					<ResponsiveRenderer
						desktop={this.renderDesktopTable()}
						tablet={this.renderTabletTable()}
					/>
				) : (
					this.renderDesktopTable()
				)}
			</div>
		);
	}

	protected renderDropZoneOverlay(): JSX.Element {
		if (!this.shouldRenderDragFilesUpload()) {
			return null;
		}

		return (
			<div
				className="dropBox"
				onDrop={this.handleDrop}
				onDragLeave={this.handleDragLeave}
				onDragEnd={this.handleDragEnd}
				onDragOver={this.handleDragOver}
				onDragEnter={this.handleDragEnter}
			>
				<div className="dropBoxContent">
					<div className="row">
						<span
							className="icon ms-Icon ms-Icon--Upload dopBoxContent-Icon"
							aria-hidden="true"
						/>
					</div>
					<div className="row">
						<span className="dopBoxContent-Heading">
							{this.viewData[DROP_INSTRUCTION]}
						</span>
					</div>
				</div>
			</div>
		);
	}

	protected renderDragArea(): JSX.Element {
		if (!this.shouldRenderDragFilesUpload()) {
			return null;
		}

		const { selectedFileSystem } = this.props;
		
		return (
			<div
				className={`${selectedFileSystem && !selectedFileSystem?.canEditMetadata ? 'notToDisplay' : 'dragArea'}`}
				onDragOver={this.handleDragOver}
				onDragEnter={this.handleDragEnter}
			>
				<span>{this.viewData[DRAG_INSTRUCTION]}</span>
			</div>
		);
	}

	protected renderDroppedFilesStageBox(): JSX.Element {
		const { droppedFiles, cleanUploadFilesState } = this.props;
		return (
			<If condition={droppedFiles?.files?.length > 0}>
				<div className="row">
					<div className="col-md-12 alert alert-success alert-dismissible fade in">
						<NavLink
							tag={Link}
							to="#"
							className="close"
							data-dismiss="alert"
							aria-label="close"
							onClick={cleanUploadFilesState}
						>
							&times;
						</NavLink>
						{this.renderUploadStages(droppedFiles.files)}
					</div>
				</div>
			</If>
		);
	}

    render() {
        if (!this.state.loaded)
            return <div className="loading" />

        const { selectedFileSystem
            , pageContentIsActive
            , isDropZone
            , isRepertoireModule
            , cleanUploadFilesState
            , entityID
            , component
        } = this.props;
        const showMetadata: boolean = selectedFileSystem ? selectedFileSystem.hasMetadata : false;
		
        let className = "container-fluid ";
        let dragAndDropContainerClassName = "formBox autoBar";
		
        if (pageContentIsActive) {
            className = className + " active";
        }

        if (!isRepertoireModule)
            className = className + " pageContent "

        if ((!entityID || entityID === 0) && isRepertoireModule) {
            dragAndDropContainerClassName = dragAndDropContainerClassName + "disabledDragAndDrop"
        }

        return (
			<div className={className}>
				{/* Header */}
				{this.renderBreadcrumbs()}

				{this.renderHeaderSection()}
				{this.shouldRenderDragFilesUpload() && this.renderStageBox()}
				{this.renderSaveStateMessage()}
				{this.renderUndoStateMessage()}

				{/* File Upload Button - only visible on tablet/mobile */}

				<If
					condition={
						(!entityID || entityID === 0) && isRepertoireModule
					}
				>
					<div className="row">
						<div className="col-md-12 alert alert-warning alert-dismissible fade in">
							<NavLink
								tag={Link}
								to="#"
								className="close"
								data-dismiss="alert"
								aria-label="close"
								onClick={cleanUploadFilesState}
							>
								&times;
							</NavLink>
							<div className="row textCenter">
								{component === AGREEMENTS_KEY ? (
									<span className="bold ">
										{
											this.viewData[
												DISABLE_DRAG_AND_DROP_AGREEMENTS
											]
										}
									</span>
								) : component === WORKS_PAGE_VIEW ? (
									<span className="bold ">
										{this.viewData[DISABLE_DRAG_AND_DROP]}
									</span>
								) : component === PRODUCTS_PAGE_VIEW ? (
									<span className="bold ">
										{
											this.viewData[
												DISABLE_DRAG_AND_DROP_PRODUCTS
											]
										}
									</span>
								) : (
									<div></div>
								)}
							</div>
						</div>
					</div>
				</If>

				{/* Files */}
				{/* Main files row - only visible on desktop */}
				<div className="row">
					{this.renderResponsiveUploadButton()}

					<div className="form-group col-md-12">
						<div className={dragAndDropContainerClassName}>
							{this.renderTableContainer()}
							{isDropZone && this.renderDropZoneOverlay()}
							{this.renderDragArea()}
						</div>
					</div>
				</div>
				<br />

				{/* Save and cancel buttons */}
				{this.renderSaveAndCancelButtons(showMetadata)}
			</div>
		);
    }
}